import { RenderDownloadButtonProps } from '../interfaces/RenderDownloadButtonProps'

import cv from '../assets/cv.pdf'

export const CV: RenderDownloadButtonProps = {
   href: cv,
   filename: 'gandoy_florido_alberto_cv.pdf',
}
